import { render, staticRenderFns } from "./OnTrialList.vue?vue&type=template&id=4a108cd8&scoped=true&"
import script from "./OnTrialList.vue?vue&type=script&lang=js&"
export * from "./OnTrialList.vue?vue&type=script&lang=js&"
import style0 from "./OnTrialList.vue?vue&type=style&index=0&id=4a108cd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a108cd8",
  null
  
)

export default component.exports